import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, watch } from 'vue';
import store, { config, userConfig, pageSizeConfig } from '@/store';
import tagApi, { tagItemType } from '@/api/tag';
import mangaApi from '@/api/manga';
import manga from '@/components/manga.vue';
import mediaPager from '@/components/media-pager.vue';
import i18n from '@/i18n';
import { mangaPageSize } from '@/store/page-size';
import { screenType } from '@/type/store';
type mangaItemType = {
    browseType: string;
    chapterCount: number;
    createTime: string;
    direction: number;
    mangaCover: string;
    mangaId: number;
    mangaName: string;
    mangaPath: string;
    mangaTagId: number;
    mediaId: number;
    pathId: number;
    removeFirst: number;
    updateTime: string;
    blob: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = i18n.global;

let pageSizes: number[] = [];
let defaultPageSize = 10;

get_page_size_array();

function get_page_size_array() {
    const screen: screenType = config.screenType;

    pageSizes = mangaPageSize[screen];
    defaultPageSize = mangaPageSize[screen][0];
}

const page = ref(1);
const pageSize = ref(10);
// 漫画列表
let mangaList = ref<mangaItemType[]>([]);
const count = ref(0);
// 标签列表
const tagList = ref<tagItemType[]>([]);
// 标签id拼接
const tagIds = computed<string>(() => {
    const str = tagList.value
        .filter(i => i.checked)
        .map(i => i.tagId).join(',');
    return str;
});

/**
 * @description: 根据标签是否被选择,改变其样式
 * @param {*} computed
 * @return {*}
 */
const tagStyle = computed(() => {

    return function (checked: boolean, color: string) {
        const style = {
            backgroundColor: color,
            color: '#ffffff'
        }

        return checked ? style : {};
    }
})

let mangaInfo = ref({});
let menuPoster = '';

/**
 * 打开右侧菜单
 */
function context_menu(mangaItem: mangaItemType) {
    menuPoster = mangaItem.blob;
    config.rightSidebar = true;
}

// 切换排序规则时 重新加载列表
watch(
    () => userConfig.order,
    () => {
        page_change(1);
    }
);

async function onChange(tagItem: tagItemType, status: boolean) {
    tagItem.checked = status;
    page_change(page.value);
}

onMounted(async () => {
    tagList.value = await tagApi.get_nopage();
})

/**
 * 跳页
 * @param page
 * @param pageSize
 */
async function page_change(
    pageC = 1,
    pageSize: number = defaultPageSize
) {
    page.value = pageC;
    mangaList.value = [];
    const res = await mangaApi.get_by_tags(tagIds.value, page.value, pageSize, userConfig.order);
    mangaList.value = res.list;
    count.value = res.count;
}

const __returned__ = { t, get pageSizes() { return pageSizes }, set pageSizes(v) { pageSizes = v }, get defaultPageSize() { return defaultPageSize }, set defaultPageSize(v) { defaultPageSize = v }, get_page_size_array, page, pageSize, get mangaList() { return mangaList }, set mangaList(v) { mangaList = v }, count, tagList, tagIds, tagStyle, get mangaInfo() { return mangaInfo }, set mangaInfo(v) { mangaInfo = v }, get menuPoster() { return menuPoster }, set menuPoster(v) { menuPoster = v }, context_menu, onChange, page_change, get config() { return config }, manga, mediaPager }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})